import { Accordion } from '@chakra-ui/react';
import Button from '@/trio-ui/Button';
import Modal from '@/trio-ui/Modal';
import { PTORequest, PTOStatus } from '@/types/api';
import { ModalPTORequestItemContainer, Footer } from './EditTimeoffRequestModal.styles';
import AnswerTimeoffRequestModal from '../AnswerTimeoffRequestModal';
import PTORequestItem, { PTORequestItemContainerProps } from '../PTORequestItem';

export type Props = Pick<PTORequestItemContainerProps, 'staffMember' | 'isLoadingStaffMember'> & {
  request: PTORequest;
  onClose: () => void;
  isOpen?: boolean;
  isLoading?: boolean;
  onOpenPTOAnswerDialog: (answer: PTOStatus.APPROVED | PTOStatus.DENIED) => void;
  status: PTOStatus.APPROVED | PTOStatus.DENIED;
  isAnswerModalOpen?: boolean;
  managerId: string;
  onUpdateRequest?: () => void;
  onCloseAnswerModal: () => void;
};

const EditTimeoffRequestModal = ({
  isOpen = false,
  request,
  onClose,
  isLoading = false,
  onOpenPTOAnswerDialog,
  status,
  isAnswerModalOpen = false,
  onCloseAnswerModal,
  onUpdateRequest,
  managerId,
  staffMember,
  isLoadingStaffMember,
}: Props): JSX.Element => {
  const EditRequestAnswerBody = (
    <>
      <ModalPTORequestItemContainer>
        <Accordion allowMultiple>
          <PTORequestItem
            ptoRequest={request}
            layout="slim"
            staffMember={staffMember}
            isLoadingStaffMember={isLoadingStaffMember}
          />
        </Accordion>
      </ModalPTORequestItemContainer>
      <Footer>
        <Button
          variantStyle="outline"
          variantColor="blue"
          size="medium"
          onClick={() => onOpenPTOAnswerDialog(PTOStatus.APPROVED)}
          disabled={isLoading}
        >
          Approve
        </Button>
        <Button
          variantStyle="outline"
          variantColor="red"
          size="medium"
          onClick={() => onOpenPTOAnswerDialog(PTOStatus.DENIED)}
          disabled={isLoading}
        >
          Deny
        </Button>
      </Footer>
    </>
  );

  return (
    <>
      <Modal
        size="3xl"
        modalTitle="Edit Request Answer"
        bodyRender={EditRequestAnswerBody}
        hideCancelButton
        // isButtonDisabled={updatePTOMutation.isLoading}
        onClose={onClose}
        isOpen={isOpen}
      />
      <AnswerTimeoffRequestModal
        newStatus={status}
        isOpen={isAnswerModalOpen}
        onClose={onCloseAnswerModal}
        request={request}
        managerId={managerId}
        onUpdateRequest={onUpdateRequest}
      />
    </>
  );
};

export default EditTimeoffRequestModal;
